import React from 'react';
import { Link } from '@leagueplatform/genesis-commons';
import { Link as LinkDOM } from '@leagueplatform/routing';

/* eslint-disable-next-line react/jsx-props-no-spreading */
export const GenesisRouterLink = (props) => <Link as={LinkDOM} {...props} />;
